<template>
  <div class="user-bar">
    <router-link exact :to="{ name: 'account_overview' }" class="user-initials no-deco" v-if="shopObj">
      <span>{{shopObj.name | initials}}</span>
    </router-link>
    <div class="user-info" v-if="shopObj">
      <router-link exact :to="{ name: 'account_overview' }" class="name no-deco">{{shopObj.name}}</router-link>
      <router-link exact :to="{ name: 'account_plan' }" class="no-deco"><small class="company" v-if="plan">{{plan | upperFirst}}</small></router-link>
    </div>
    <Loading :box="false" :lines="2" :paragraphs="1" :heading="false" v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import filters from '@/mixins/filters'

export default {
  computed: mapState([ 'shopObj', 'plan' ]),
  mixins: [ filters ]
}
</script>
